import React, {useEffect, useRef, useState} from 'react';
import {Helmet} from "react-helmet";
import {RouteInfo} from "../../route/RouteHelper";
import {useLoadingDispatcher} from "../../context/LoadingContext";
import "./Dashboard.scss";
import SellerName from "../../raicheComponents/sellerName/SellerName";
import PointsStatistics from "../../raicheComponents/statistics/PointsStatistics";
import {DashboardService} from "../../serverService/dashboard/DashboardService";
import {LoadingHelper} from "../../util/LoadingHelper";
import {useAuthState} from "../../context/AuthContext";
import {
    RaikoBaseCardContainer,
    RaikoChipTypes,
    convertCurrencyFormat,
    RaikoCustomSimpleChip,
    RaikoCustomTable,
    RaikoGridOneColumn,
    RaikoSectionContainer,
    showErrorMessage,
    showServerErrorMessage
} from "@moeindal/base-raiko-panel-components";
import {detectServerErrorMessage} from "../../util/detectServerErrorMessage";
import useDraggableScroll from "use-draggable-scroll";
import {CashGroupService} from "../../serverService/cashGroupService/CashGroupService";
import moment from "jalali-moment";

const Dashboard = () => {
    //drag-start
    const ref = useRef(null);
    const {onMouseDown} = useDraggableScroll(ref, {direction: 'horizontal'});
    //drag-end
    let page = 0
    const size = 20

    const loading = new LoadingHelper(useLoadingDispatcher())


    const allReportsService = new DashboardService()
    const {fundID} = useAuthState()

    const [reports, setReports] = useState({
        cashBalance: 0,
        countOfGroup: 0,
        countOfLoan: 0,
        countOfMember: 0,
        totalBalance: 0,
        totalLoanAmount: 0,
        unionTotalBalance: 0
    });


    const groupService = new CashGroupService(fundID)

    useEffect(() => {
        if (typeof groupService !== "undefined") {
            getGroupInfoFromServer()
            getDashboardReports()
        }
    }, [fundID])

    function getDashboardReports() {
        loading.show()
        allReportsService.getDashboardReports(
            fundID
        ).then(response => {
            setReports(response)
        }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            loading.hide()
        })
    }

    function prepareGroupsJsonList(
        id, itemID, code, name, inventory, numberOfDepositAccounts,
        summationOfLoans, numberOfLoans, numberOfMembers, createdDate, enabled) {
        return {
            id: id,
            number: itemID,
            code: code,
            name: name,
            loanAmount: summationOfLoans ? convertCurrencyFormat(summationOfLoans) : "0",
            numberOfLoans: numberOfLoans ? convertCurrencyFormat(numberOfLoans) : "0",
            numberOfDepositAccounts: numberOfDepositAccounts ? convertCurrencyFormat(numberOfDepositAccounts) : "0",
            userCount: numberOfMembers ? convertCurrencyFormat(numberOfMembers) : "0",
            cash: convertCurrencyFormat(inventory),
            createdDate: moment(createdDate, 'YYYY-M-D')
                .locale('fa')
                .format('YYYY/M/D'),
            state: enabled ?
                <RaikoCustomSimpleChip title={"فعال"} type={RaikoChipTypes.success}/>
                : <RaikoCustomSimpleChip title={"غیر فعال"} type={RaikoChipTypes.error}/>,
        };
    }


    function getGroupInfoFromServer() {
        setTableLoading(true)
        groupService.getCashGroupsList(fundID, page, size)
            .then(response => {
                    setGroupInfo([])
                    response.data.map((item, index) => {
                        setGroupInfo((prevState => [...prevState,
                            prepareGroupsJsonList(
                                item.id,
                                (page * size) + index + 1,
                                item.code,
                                item.name,
                                item.summationOfDepositAccountsBalance,
                                item.numberOfDepositAccounts,
                                item.summationOfLoans,
                                item.numberOfLoans,
                                item.numberOfMembers,
                                item.createdAt,
                                item.enabled
                            )
                        ]))
                    })
                }
            ).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            setTableLoading(false)
        })

    }

    const [tableLoading, setTableLoading] = useState(false);
    const [searchItem, setSearchItem] = useState("")
    const [filter, setFilter] = useState("")
    const [groupInfo, setGroupInfo] = useState([])

    return (
        <>
            <Helmet>
                <title>{RouteInfo.Dashboard.name}</title>
            </Helmet>
            <section className="dashboardLayout">
                <div className="dashboardContent">

                    <SellerName/>
                    <div className="statisticsLayout hideScroll" ref={ref} onMouseDown={onMouseDown}>
                        <PointsStatistics
                            title={"موجودی کل (ریال)"}
                            amount={reports.totalBalance}
                        />
                        <PointsStatistics
                            title={"مجموع پس انداز (ریال)"}
                            amount={reports.cashBalance}
                        />
                        <PointsStatistics
                            title={"موجودی اتحادیه (ریال)"}
                            amount={reports.unionTotalBalance}
                        />
                        <PointsStatistics
                            title={"تعداد وام ها"}
                            amount={reports.countOfLoan}
                        />
                        <PointsStatistics
                            title={"مجموع وام ها (ریال)"}
                            amount={reports.totalLoanAmount}
                        />
                        <PointsStatistics
                            title={"تعداد اعضا"}
                            amount={reports.countOfMember}
                        />

                    </div>
                    <RaikoBaseCardContainer>
                        <RaikoGridOneColumn>
                            <RaikoSectionContainer title={"خلاصه وضعیت صندوق"}>
                                <RaikoCustomTable
                                    isLoading={tableLoading}
                                    data={groupInfo}
                                    header={columns}
                                />
                            </RaikoSectionContainer>
                        </RaikoGridOneColumn>
                    </RaikoBaseCardContainer>

                </div>
                {/* <div className="dashboardWrapper">
                    <DigitalClock/>
                    <SidebarHolidaysList/>
                    <GeneralStoreInformation storeName={storeName}/>
                    <EducationalVideosInDashboardPage/>
                    <DailyNotifications/>
                </div>*/}

            </section>
        </>

    )
}

export default Dashboard;
const columns = [
    {
        id: 'number',
        label: '#',
    },
    {
        id: 'code',
        label: 'کد',
    },
    {
        id: 'name',
        label: 'نام',
    },
    {
        id: 'cash',
        label: 'موجودی (ریال)',
    },
    {
        id: 'numberOfLoans',
        label: 'تعداد وام ها',
    },
    {
        id: 'loanAmount',
        label: 'مجموع وام ها (ریال)',
    },
    {
        id: 'userCount',
        label: 'اعضا',
    },
    {
        id: 'numberOfDepositAccounts',
        label: 'تعداد حساب ها',
    },
    {
        id: 'createdDate',
        label: 'تاریخ ساخت',
    },
    {
        id: 'state',
        label: 'وضعیت',
    },
];
